const connectors = {
  addConnector: 'Add a connector',
  cancelConnectorRun: 'Cancel run',
  chooseConnectorType: 'Choose a connector',
  connectorBillingRequired: 'Each connector run costs $0.01. Add a payment method before creating a connector.',
  connectorDescription_GITHUB: 'Monitor a GitHub repository',
  connectorDescription_STRAVA: 'Monitor a Strava athlete',
  connectorDescription_SUBSTACK: 'Monitor a Substack publication',
  connectorDescription_YOUTUBE: 'Monitor a YouTube channel',
  connectorFollowerCount_one: '{{count}} follower',
  connectorFollowerCount_other: '{{count}} followers',
  connectorOpenIssueCount_one: '{{count}} open issue',
  connectorOpenIssueCount_other: '{{count}} open issues',
  connectorOpenPullRequestCount_one: '{{count}} open pull request',
  connectorOpenPullRequestCount_other: '{{count}} open pull requests',
  connectorPostCount_one: '{{count}} post',
  connectorPostCount_other: '{{count}} posts',
  connectorRunBilledUnits_one: '{{count}} billed unit',
  connectorRunBilledUnits_other: '{{count}} billed units',
  connectorRunCharge: '${{amount}}',
  connectorRunStatus_cancelled: 'Cancelled',
  connectorRunStatus_error: 'Error',
  connectorRunStatus_queued: 'Queued',
  connectorRunStatus_success: 'Success',
  connectors: 'Connectors',
  connectorStarCount_one: '{{count}} star',
  connectorStarCount_other: '{{count}} stars',
  connectorSubscriberCount_one: '{{count}} subscriber',
  connectorSubscriberCount_other: '{{count}} subscribers',
  connectorType_GITHUB: 'GitHub',
  connectorType_STRAVA: 'Strava',
  connectorType_SUBSTACK: 'Substack',
  connectorType_YOUTUBE: 'YouTube',
  connectorYtdRide_one: '{{count}} ride · {{distance}} km this year',
  connectorYtdRide_other: '{{count}} rides · {{distance}} km this year',
  connectorYtdRun_one: '{{count}} run · {{distance}} km this year',
  connectorYtdRun_other: '{{count}} runs · {{distance}} km this year',
  connectorYtdSwim_one: '{{count}} swim · {{distance}} km this year',
  connectorYtdSwim_other: '{{count}} swims · {{distance}} km this year',
  failedToLoadConnectors: 'Could not load connectors',
  githubRepository: 'Repository',
  noConnectorRunsToDisplay: 'No runs to display',
  noConnectorsMatchSearch: 'No connectors match your search',
  noConnectorsToDisplay: 'No connectors to display',
  noConnectorTypesMatchSearch: 'No connector types match your search',
  provideGitHubRepository: 'Enter a GitHub repository as owner/repo or a github.com URL.',
  provideHandleOrChannelId: 'Enter a channel handle or a channel ID, not both.',
  provideStravaAthlete: 'Enter a numeric athlete ID or a strava.com/athletes/{id} URL.',
  provideSubstackUrl: 'Enter a Substack publication URL or subdomain.',
  runConnector: 'Run connector',
  searchConnectors: 'Search connectors',
  stravaAthlete: 'Athlete ID or profile URL',
  substackUrl: 'Publication URL',
  youtubeChannelId: 'Channel ID',
  youtubeHandle: 'Channel handle',
};

export default connectors;
